import { Injectable, inject } from '@angular/core';

import {
  ModuleInstanceRequestParams,
  MultipleModuleScreenValuesModel,
  SaveMultipleTransitionScreensBody,
  SaveTransitionScreenBody,
  TriggerMultipleTransitionScreensOrTemplatesRequest,
  TriggerMultipleTransitionScreensOrTemplatesResult,
} from '@models/api';
import { KeyValueUserModel } from '@models/common';
import { DocumentInfoModel } from '@module-instance/dynamic-module/document-details/common';
import { HttpService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class ModuleInstanceCommonService {
  private http = inject(HttpService);

  getGeneralInformation({
    moduleId,
    entityInstanceId,
    paymentPeriodId,
    moduleTypeId,
    contractId,
    sovEntityInstanceId,
  }: ModuleInstanceRequestParams) {
    const params = this.http.buildHttpParams({
      moduleId,
      entityInstanceId,
      paymentPeriodId,
      moduleTypeId,
      contractId,
      sovEntityInstanceId,
    });
    return this.http.get<DocumentInfoModel>('_api/ModuleInstanceCommon/GetGeneralInformationEntityInstance', {
      httpOptions: { params },
      useLoader: false,
    });
  }

  saveMultipleTransitionScreensOrTemplates(
    { moduleId, workflowId, contractId, transitionId, roleId }: ModuleInstanceRequestParams,
    body: SaveMultipleTransitionScreensBody,
  ) {
    const params = this.http.buildHttpParams({ moduleId, workflowId, contractId, transitionId, roleId });
    return this.http.post<number[]>('_api/ModuleInstanceCommon/SaveMultipleTransitionScreensOrTemplates', body, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  triggerMultipleTransitionScreensOrTemplates(params: TriggerMultipleTransitionScreensOrTemplatesRequest) {
    return this.http.post<TriggerMultipleTransitionScreensOrTemplatesResult>(
      '_api/ModuleInstanceCommon/TriggerMultipleTransitionScreensOrTemplates',
      params,
      {
        useLoader: false,
      },
    );
  }

  addMultipleComment(
    body: MultipleModuleScreenValuesModel,
    moduleId: number,
    actionId: number,
    contractId?: number,
    roleId?: number,
  ) {
    const params = this.http.buildHttpParams({ moduleId, actionId, contractId, roleId });
    return this.http.post<void>('_api/ModuleInstanceCommon/AddMultipleComment', body, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  saveTransitionScreen(
    params: Pick<
      ModuleInstanceRequestParams,
      'entityInstanceId' | 'contractId' | 'moduleId' | 'workflowId' | 'roleId' | 'transitionId'
    >,
    body?: Partial<SaveTransitionScreenBody>,
  ) {
    const httpParams = this.http.buildHttpParams(params);
    return this.http.post<number>('_api/ModuleInstanceCommon/SaveTransitionScreen', body, {
      httpOptions: { params: httpParams },
      useLoader: false,
    });
  }

  getUserRoleEmails(moduleId: number, entityInstanceId: number, stateId?: number, contractId?: number) {
    const params = this.http.buildHttpParams({ moduleId, stateId, entityInstanceId, contractId });
    return this.http.get<KeyValueUserModel<string>[]>('_api/ModuleInstanceCommon/GetUserRoleEmails', {
      httpOptions: { params },
      useLoader: false,
    });
  }
}
